import { AbstractControl, ValidationErrors } from "@angular/forms";
import { DateTime } from "luxon";

export function toFromDateValidator(control: AbstractControl): ValidationErrors | null {
    const parent = control.parent;
    if (!parent) {
        return null;
    }

    const fromDateValue = parent.get('fromDate')?.value;
    const toDateValue = parent.get('toDate')?.value;
    if (!fromDateValue || !toDateValue) {
        return null;
    }

    const fromDate = DateTime.fromISO(fromDateValue);
    const toDate = DateTime.fromISO(toDateValue);

    if (fromDate < toDate) {
        return { toFromDate: true };
    }

    return null;
}